import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseStyle = _resolveComponent("BaseStyle")!

  return (_openBlock(), _createBlock(_component_BaseStyle, {
    model: _ctx.model,
    class: "content-base"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseItems, (targetItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: targetItem.name,
          class: "flex px-5 py-6 items-start"
        }, [
          _createElementVNode("div", {
            class: "w-7/12",
            textContent: _toDisplayString(targetItem.name)
          }, null, 8, _hoisted_1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((targetItem.count) = $event),
            class: "w-2/12 mx-5 p-1 text-center border rounded",
            type: "number",
            min: "0"
          }, null, 8, _hoisted_2), [
            [
              _vModelText,
              targetItem.count,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("div", {
            class: "w-3/12 text-left",
            textContent: _toDisplayString(targetItem.itemUnit)
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model"]))
}